import React, { FunctionComponent } from 'react'
import { InjectedIntlProps, injectIntl } from 'react-intl'
import { formattedDateStartTimeFixedTZ, getTimeLeft } from 'src/lib/formatter'
import { EVENT_STATES } from 'src/constants/constants'
import locale from '../locale'

// Reuse styles from TicketWidget
const style = require('./TicketWidget.css')

export const shouldShowFanReminderData = (listingStatus: string) =>
  listingStatus === EVENT_STATES.fanReminderWaitlistEnabled ||
  listingStatus === EVENT_STATES.fanReminderWaitlistEnabledWithLockedTickets


interface Props {
  listingStatus: string;
  fanReminderEndStamp: number;
  timezone: string;
  cta?: React.ReactNode;
}

const FanReminderComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  listingStatus,
  fanReminderEndStamp,
  timezone,
  cta,
  intl,
}) => {
  const fanReminderEndStampDate = new Date((fanReminderEndStamp) * 1000)
  const { days, hours, mins } = getTimeLeft(fanReminderEndStampDate)

  if (!shouldShowFanReminderData(listingStatus)) return null

  return (
    <div>
      <p className={style.comingSoonText}>
        {intl.formatMessage(locale.onsaleComingSoon).toLocaleUpperCase()}
      </p>
      <p className={style.dateText}>
        {formattedDateStartTimeFixedTZ({
          startAt: fanReminderEndStampDate,
          intl,
          tz: timezone,
          shortenTz: true,
        })}
      </p>
      <div className={style.fanReminderFooter}>
        <p className={style.startsInText}>
          {intl.formatMessage(locale.timeUntilSaleStarts, {
            days,
            hours,
            mins,
          })}
        </p>
        {cta && <div className={style.ctaWrapper}>{cta}</div>}
      </div>
    </div>
  )
}

export const FanReminderInfo = injectIntl(FanReminderComponent)
